<template>
  <main class="content">
    <header class="content-header mb-16">
      <h1 class="black--text">
        Erro
      </h1>
      <h2 class="black--text">
        {{ httpError }}
      </h2>
    </header>

    <footer class="footer-content mt-16">
      <h1 class="black--text">
        {{ errorMessage }}
      </h1>
      <p class="desc"></p>
      <button
        @click="submit"
      >
        Voltar
      </button>
    </footer>
  </main>
</template>

<script>

export default {
  data() {
    return {
      httpError: '',
      errorMessage: '',
      fromUrl: '',
    }
  },
  created() {
    this.httpError = this.$router.history.current.query.http_error
    this.errorMessage = this.$router.history.current.query.error_message
    this.fromUrl = this.$router.history.current.query.from_url

    switch (this.errorMessage) {
      case 'expired key':
        this.errorMessage = 'Ticket expirado! Por favor, volte para a aplicação de origem e tente novamente.'
        break
      case 'invalid key':
        this.errorMessage = 'Chave inválida! Por favor, volte para a aplicação de origem e tente novamente.'
        break
      default:
        this.errorMessage = 'Encontramos um erro! Por favor, volte para a aplicação de origem e tente novamente.'
        break
    }
  },
  methods: {
    submit() {
      this.$router.push(`/redirect?url=${this.fromUrl}`)
    },
  },
}
</script>

<style scoped>
main {
  background: url(../../assets/images/3d-characters/erro.svg);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  border: 0;
  box-sizing: border-box;
}

.content {
  height: 100%;
  display: flex;
  place-items: center;
  flex-direction: column;
  justify-content: center;
}

.content-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 250px;
  max-width: 300px;
  width: 100%;
  margin-left: 50px;
  margin-bottom: 30px;
  padding: 25px;
  box-sizing: border-box;
}

.content-header h1 {
  display: block;
  color: #9fa8bfff;
  text-align: center;
  font-size: 2rem;
  line-height: 1;
  margin: 0;
  text-transform: uppercase;
}

.content-header h2 {
  display: block;
  color: #9fa8bfff;
  text-align: center;
  font-size: 4rem;
  line-height: 1;
  margin: 0;
  text-transform: uppercase;
}

.footer-content {
  display: flex;
  flex-direction: column;
  place-items: center;
  justify-content: flex-end;
  max-width: 600px;
  width: 100%;
  height: 300px;
  padding: 25px;
  box-sizing: border-box;
  text-align: center;
}

.footer-content h1 {
  display: block;
  color: #9fa8bfff;
  text-align: center;
  font-size: 2rem;
  line-height: 1;
  margin: 0;
  text-transform: uppercase;
}

.footer-content button {
  display: flex;
  place-items: center;
  justify-content: center;
  color: #fff;
  background-color: #00559b;
  border-color: #00559b;
  border: 0;
  border-radius: 20px;
  padding: 10px 30px;
  margin-top: 30px;
  cursor: pointer;
}
p.desc {
  color: #9fa8bfff;
}

@media (min-width: 992px) {
  .content-header {
    height: 300px;
    margin-left: 70px;
  }

  .content-header h1 {
    font-size: 3rem;
  }

  .content-header h2 {
    font-size: 6rem;
  }
}

@media (max-width: 768px) {
  .footer-content h1{
    font-size: 1.5rem;
  }
}
</style>
